<template>
<v-layout justify-center>
    <v-responsive max-width="1280px" width="100%" height="100%">
        <v-row class="mt-8" justify="center" align="center">
            <v-col cols="auto" class="pt-0 pb-0 headline text-start">CP 캐시내역</v-col>
            <v-spacer></v-spacer>
            <v-col cols="auto" class="pt-0 pb-0">
                <v-btn class="ma-2" color="secondary" rounded @click="showSearch = !showSearch">
                    <v-icon small class="mr-2">mdi-filter-variant</v-icon>검색필터
                </v-btn>
            </v-col>
        </v-row>

        <v-expand-transition>
            <v-card v-show="showSearch" class="elevation-1 mx-auto">
                <v-card-title class="subtitle-2 font-weight-bold">검색필터</v-card-title>
                <v-card-text>
                    <v-row align="center">
                        <v-col cols="12" sm="6" class="py-0">
                            <v-date-field v-model="filter.createdAt[0]" label="내역일자" placeholder=" " hide-details></v-date-field>
                        </v-col>
                        <v-col cols="12" sm="6" class="py-0">
                            <v-date-field v-model="filter.createdAt[1]" label="내역일자" placeholder=" " hide-details></v-date-field>
                        </v-col>
                    </v-row>
                    <v-row align="center" class="mt-3">
                        <v-col cols="12" sm="3" class="py-0">
                            <v-select v-model="filter.searchKey" :items="searchKeys" item-text="name" item-value="value" label="검색조건" placeholder=" " hide-details @change="filter.searchValue = null;"></v-select>
                        </v-col>
                        <v-col cols="12" sm="3" class="py-0">
                            <v-text-field v-model="filter.searchValue" label="검색어" placeholder=" " hide-details :disabled="!filter.searchKey"></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" rounded text @click="search">
                        <v-icon small class="mt-1 mr-2">mdi-magnify</v-icon>검색
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-expand-transition>

        <v-row class="mt-4">
            <v-spacer></v-spacer>
            <v-col cols="auto">
                <v-btn color="white" class="green--text px-2" @click="excel">
                    <v-icon class="mr-2">{{ mdiMicrosoftExcel }}</v-icon>엑셀다운로드
                </v-btn>
            </v-col>
        </v-row>
        <v-data-table :items="cashes" :headers="cashesHeaders" disable-sort disable-pagination hide-default-footer class="elevation-1">
            <template v-slot:item.cp.phone="{ item }">
                <span v-if="item.cp.phone">{{ item.cp.phone.phoneNumberFormat() }}</span>
                <span v-else>-</span>
            </template>
            <template v-slot:item.createdAt="{ item }">
                <span v-if="item.createdAt">{{ item.createdAt.toDateTime() }}</span>
                <span v-else>-</span>
            </template>
            <template v-slot:item.warning="{ item }">
                <v-row justify="center" align="center">
                    <v-col cols="auto" class="pa-0">
                        <v-switch v-model="item.warning" color="red lighten-1" hide-details dens class="mt-0" @change="updateUser({ _id: item._id, warning: item.warning })"></v-switch>
                    </v-col>
                </v-row>
            </template>
            <template v-slot:item.price="{ item }">
                <span v-if="item.price">{{ item.price.format() }}원</span>
                <span v-else>-</span>
            </template>
            <template v-slot:item.remain="{ item }">
                <span v-if="item.remain">{{ item.remain.format() }}원</span>
                <span v-else>-</span>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon small @click="edit(item)"> mdi-pencil </v-icon>
            </template>
        </v-data-table>
        <v-pagination v-model="page" :length="pageCount" :total-visible="11" class="mt-4 mb-12 mx-4" @input="search()"></v-pagination>

    </v-responsive>
</v-layout>
</template>

<script>
import XLSX from "xlsx";
import api from "@/api";
import vDateField from "@/components/plugins/vuetify/v-date-field.vue";

import { mdiMicrosoftExcel } from "@mdi/js";

export default {
    components: {
        vDateField
    },
    props: {
        viewType: String,
    },
    data() {
        return {
            mdiMicrosoftExcel, // 엑셀아이콘

            showSearch: true,

            filter: {
                createdAt: ["", ""],
                searchKey: null,
                searchValue: null
            },

            page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 10,

            cashes: [],
            cashesHeaders: [{
                    text: "CP 이름",
                    align: "center",
                    width: 200,
                    value: "cp.name",
                },
                {
                    text: "비고",
                    align: "center",
                    value: "remark",
                },
                {
                    text: "금액",
                    width: 150,
                    align: "center",
                    value: "price",
                },
                {
                    text: "남은금액",
                    width: 150,
                    align: "center",
                    value: "remain",
                },
                {
                    text: "내역일자",
                    align: "center",
                    width: 200,
                    value: "createdAt",
                },
            ],

            searchKeys: [
                { name: ":: 전체 ::", value: null },
                { name: "CP 이름", value: "cp.name" },
                { name: "CP 연락처", value: "cp.phone" }
            ]
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            try {
                this.search();
            } catch (error) {
                console.error(error);
            }
        },
        async search() {
            try {
                var { summary, cashes } = await api.console.me.cps.cashes.gets({
                    headers: {
                        skip: (this.page - 1) * this.limit,
                        limit: this.limit,
                    },
                    params: this.filter,
                });

                this.cashes = cashes;
                this.pageCount = Math.ceil(summary.totalCount / this.limit);
            } catch (error) {
                console.error(error);
            }
        },

        create(){
            this.$router.replace(`/console/cashes/create`);
        },

        async excel() {
            try {
                var { cashes } = await api.console.me.cps.cashes.gets({
                    params: this.filter,
                });

                var data = [];
                for(var cash of cashes){
                    data.push({
                        "CP 이름": cash.cp?.name,
                        "비고": cash.remark,
                        "금액": parseInt(+cash.price || 0).format(),
                        "남은금액": parseInt(+cash.remain || 0).format(),
                        "내역일자": cash.createdAt?.toDateTime(),
                    });
                }

                var workbook = new XLSX.utils.book_new();
                var worksheet = XLSX.utils.json_to_sheet(data);

                XLSX.utils.book_append_sheet(workbook, worksheet, "new");
                XLSX.writeFile(workbook, "CP 캐시내역.xlsx");
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
    },
    computed: {
        test(){
            return this.$store.state.test;
        }
    }
};
</script>
